import Login from "../Pages/auth/Login";
import {
  BadlaHistory,
  BadlaRate,
  Dashboard,
  LiveMarket,
  ManageBadla,
  SettlementList,
  Summary,
} from "../Pages";

export const authRouter = [
  // {
  //   path: "/",
  //   component: Dashboard,
  //   exact: true,
  // },
  {
    path: "/live-market",
    component: LiveMarket,
    exact: true,
  },
  {
    path: "/badla-rate",
    component: BadlaRate,
    exact: true,
  },
  {
    path: "/manage-badla",
    component: ManageBadla,
    exact: true,
  },
  {
    path: "/badla-history",
    component: BadlaHistory,
    exact: true,
  },
  {
    path: "/settlement-list",
    component: SettlementList,
    exact: true,
  },
  {
    path: "/summary",
    component: Summary,
    exact: true,
  },
];

export const publicRouter = [
  {
    path: "/login",
    component: Login,
  },
];
